import { Box } from "@mui/material";
import React from "react";
import TabNavButton from "../../types/tabNavButton";
import { Base } from ".";

interface Props {
  activeTab: number;
  setActiveTab: React.Dispatch<React.SetStateAction<number>>;
  tabs: TabNavButton[];
  activeBackgroundColor?: string;
  disabled?: boolean;
  disabledIndex?: number[];
  disabledMessage?: (step: TabNavButton) => void;
}

const Tabs: React.FC<Props> = (props) => {
  const {
    tabs,
    activeTab,
    setActiveTab,
    activeBackgroundColor,
    disabled,
    disabledIndex,
    disabledMessage,
  } = props;

  const handleTabChange = (tabNumber: number) => {
    setActiveTab(tabNumber);
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: 1,
        }}
      >
        {tabs.map((step, index) => {
          const disabledTab = disabledIndex?.find((i) => i === index);
          return (
            <Box
              key={index}
              sx={{
                flex: 1,
              }}
              onClick={() => {
                if (disabledTab && disabled) {
                  disabledMessage?.(step);
                } else {
                  handleTabChange(index);
                }
              }}
            >
              <Base.Tab
                label={step.label}
                index={index}
                activeTab={activeTab}
                activeBackgroundColor={activeBackgroundColor}
                icon={step.icon}
                color={step.color}
                disabled={disabledTab === index && disabled}
              />
            </Box>
          );
        })}
      </Box>
    </>
  );
};

export default Tabs;
